import React from 'react';
import { APP_NAME, BASE_URL } from '@apps/config';
import { serializeJsonLd } from '@apps/utils/serialize-json-ld';
import Head from 'next/head';

import { PersonStructuredDataProps } from './props';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const PersonStructuredData: React.FC<PersonStructuredDataProps> = (
  props
) => {
  const { author, url } = props;

  // =============== VARIABLES
  if (!author?.name) return null;

  const sameAs = Object.values(author.social ?? {})
    .map((social) => {
      return social?.user_social_url;
    })
    .filter((socialUrl): socialUrl is string => {
      return !!socialUrl;
    });

  const personSchema = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: author.name,
    url,
    ...(author.image ? { image: author.image } : {}),
    ...(author.description ? { description: author.description } : {}),
    ...(author.role ? { jobTitle: author.role } : {}),
    ...(sameAs.length > 0 ? { sameAs } : {}),
    worksFor: {
      '@type': 'Organization',
      name: APP_NAME,
      url: BASE_URL,
    },
  };

  // =============== VIEWS
  return (
    <Head>
      <script
        type="application/ld+json"
        key="person-schema"
        dangerouslySetInnerHTML={{ __html: serializeJsonLd(personSchema) }}
      />
    </Head>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export * from './props';
export default PersonStructuredData;
